import React from 'react';

import RichEditorContent from 'components/RichEditorContent';

import TimelineHeader from 'components/layout/embeddedTimeline/common/TimelineHeader';

import * as timelineComponents from 'components/layout/embeddedTimeline';
import * as timelineIcons from 'components/layout/embeddedTimeline/icons';

export default class EmbeddedTimelineEvent extends React.Component {
  hasOwnRenderer = () => {
    const componentName = this.getComponentName();
    const component = this.getComponentByName(componentName);

    return !!component;
  };

  getComponentName = (prefix = 'Timeline') => {
    const { event } = this.props;
    const type = event && event.getType() ? event.getType() : '';
    // return prefix + type.charAt(0).toUpperCase() + type.slice(1);

    const componentName =
      prefix +
      (type.charAt(0).toUpperCase() + type.slice(1)).replace(/_([a-z])/g, g => {
        return g[1].toUpperCase();
      });

    // console.log(componentName);
    return componentName;
  };

  getComponentByName = name => {
    if (timelineComponents[name] !== undefined) {
      return timelineComponents[name];
    }
  };

  getTimelineIcon = () => {
    const timelineIconComponentName = this.getComponentName('TimelineIcon');
    if (timelineIcons[timelineIconComponentName] !== undefined) {
      const RenderComponent = timelineIcons[timelineIconComponentName];
      return <RenderComponent />;
    }

    return <div className="timeline-point small" />;
  };

  render() {
    const { event, date } = this.props;

    let content = (
      <div className="card-description">
        <RichEditorContent content={'<p>' + event.getText() + '</p>'} />
      </div>
    );
    if (this.hasOwnRenderer()) {
      const RenderComponent = this.getComponentByName(this.getComponentName());
      content = <RenderComponent event={event} />;
    }

    return (
      <div className="timeline-block">
        {this.getTimelineIcon()}
        <div className="timeline-content">
          <div className="card social-card share full-width">
            <TimelineHeader publicCreator={event.getPublicCreator()} />

            {content}
          </div>
          <div className="event-date">
            <small className="fs-12 hint-text">{date}</small>
          </div>
        </div>
      </div>
    );
  }
}
